.scene {
  position: absolute;
  inset: 0;
  overflow: hidden;
  background:
    radial-gradient(120% 90% at 65% 45%, rgba(40, 52, 66, 0.5), transparent 60%),
    linear-gradient(180deg, #0a0d11 0%, #0e1217 55%, #0a0d11 100%);
}
/* The points (WebGL) and, over them, the labels and lines (2D). */
.canvas {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
}

/* ---- the readout: one analysis's numbers, in its own colour ---------------- */
.hud {
  position: absolute;
  z-index: 2;
  right: var(--sp-6);
  /* Clear of the site's floating accessibility button, in the same corner. */
  bottom: calc(var(--sp-6) + 4.5rem);
  width: 19rem;
  padding: var(--sp-4) var(--sp-5);
  border: 1px solid color-mix(in srgb, var(--tint) 45%, rgba(255, 255, 255, 0.14));
  border-radius: var(--radius-lg);
  background: rgba(11, 14, 18, 0.78);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  box-shadow: var(--shadow-lg);
  color: var(--text-on-dark);
  font-size: var(--fs-sm);
  transition: border-color 400ms var(--ease);
}
.hudHead {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
  margin: 0 0 var(--sp-3);
  font-weight: 600;
}
/* A phone's one line in place of the rows. */
.summary {
  display: none;
}
.readout {
  display: grid;
  gap: 6px;
  margin: 0;
}
.readout div {
  display: flex;
  justify-content: space-between;
  gap: var(--sp-4);
}
.readout dt {
  color: var(--asphalt-400);
}
.readout dd {
  margin: 0;
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  text-align: right;
  color: var(--asphalt-100);
}
.status {
  margin: var(--sp-3) 0 0;
  padding: 0.35rem 0.6rem;
  border-radius: var(--radius-sm);
  font-weight: 700;
  text-align: center;
}
.status[data-tone="ok"] {
  color: #46d696;
  background: rgba(70, 214, 150, 0.12);
}
.status[data-tone="warn"] {
  color: #fbb03c;
  background: rgba(251, 176, 60, 0.14);
}
.status[data-tone="fail"] {
  color: #ff8a3d;
  background: rgba(248, 128, 0, 0.16);
}
.status[data-tone="info"] {
  color: var(--asphalt-300);
  background: rgba(255, 255, 255, 0.08);
}

@media (min-width: 48rem) and (max-width: 74.99rem) {
  /* Tablets and small laptops: the headline number and the verdict, not the whole table,
     so the readout stays clear of what the shot frames beside the text. */
  .hud {
    width: 16rem;
  }
  .readout {
    display: none;
  }
  .summary {
    display: block;
    margin: 0;
    font-weight: 600;
  }
}

@media (max-width: 47.99rem) {
  /* One line under the floating header: the scene keeps the band between it and the step. */
  .hud {
    top: calc(var(--header-h) + 2 * var(--header-margin));
    left: var(--sp-4);
    right: var(--sp-4);
    bottom: auto;
    display: flex;
    align-items: center;
    gap: var(--sp-2);
    width: auto;
    padding: var(--sp-2) var(--sp-3);
    font-size: 0.75rem;
  }
  .hudHead {
    margin: 0;
  }
  .hudTitle,
  .readout {
    display: none;
  }
  .summary {
    display: block;
    flex: 1;
    min-width: 0;
    margin: 0;
    overflow: hidden;
    font-weight: 600;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .status {
    margin: 0;
    padding: 0.2rem 0.5rem;
    white-space: nowrap;
  }
}
